import { PoolType } from 'proto/Offer/Accommodation/PoolType';

const poolTypeToUrlValueMap: Partial<Record<PoolType, string>> = {
    [PoolType.Jacuzzi]: 'jacuzzi',
    [PoolType.PrivatePool]: 'private',
    [PoolType.SwimUp]: 'swimUp',
};

const urlValueToPoolTypeMap: Partial<Record<string, PoolType>> =
    Object.fromEntries(
        Object.entries(poolTypeToUrlValueMap).map(([key, value]) => [
            value,
            key as PoolType,
        ])
    );

export const convertPoolTypeToUrlValue = (poolType: PoolType) =>
    poolTypeToUrlValueMap[poolType];

export const convertUrlValueToPoolType = (urlValue: string) =>
    urlValueToPoolTypeMap[urlValue];
